import React from 'react';

const SendFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path id="send-fill_svg__a" d="M3 20l18-8L3 4v7.1l12.6.9-12.6.9z" />
        </defs>
        <clipPath id="send-fill_svg__b">
            <use xlinkHref="#send-fill_svg__a" overflow="visible" />
        </clipPath>
        <g clipPath="url(#send-fill_svg__b)">
            <defs>
                <path id="send-fill_svg__c" d="M0 0h24v24H0z" />
            </defs>
            <clipPath id="send-fill_svg__d">
                <use xlinkHref="#send-fill_svg__c" overflow="visible" />
            </clipPath>
            <path clipPath="url(#send-fill_svg__d)" d="M-2-1h28v26H-2z" />
        </g>
    </svg>
);

SendFillSvg.displayName = 'SendFillSvg';
export default SendFillSvg;
